import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

function DeleteObjectModal({
  isOpen, onClose, onDelete, isLoading, row, objectType,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="modal-backdrop"
        onClick={onClose}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            onClose();
          }
        }}
        tabIndex={-1}
        aria-hidden="true"
      />

      <div className="modal w-[400px]">
        <div className="modal-header">
          <h2 className="text-lg font-semibold text-surface-900">
            {`Delete ${objectType}`}
          </h2>
        </div>
        <div className="modal-body">
          <p className="text-sm text-surface-600">
            {`Are you sure you want to delete this ${objectType}?`}
          </p>
          <p className="text-sm font-medium text-error-dark mt-2">
            This action cannot be undone.
          </p>
        </div>
        <div className="modal-footer">
          {isLoading ? (
            <ClipLoader size={20} color="#D4532A" />
          ) : (
            <>
              <button
                type="button"
                onClick={() => onClose(true)}
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => onDelete(row)}
                className="btn btn-danger"
              >
                Delete
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default DeleteObjectModal;
